export type UUID = {
  readonly service: string
  readonly characteristic: string
}

export type ScanOptions = {
  nodeType?: string
  nodeId?: string
}

export enum AdapterStatus {
  DISABLED,
  IDLE,
  SCANNING,
  CONNECTING,
  CONNECTED,
}

export class DTO {}

export type DtoConstructor = new () => DTO

export type Decoder<T extends DTO> = Convertor<T> & {
  decode(data: DataView): T | null
  notifiable?: boolean
}

export type Encoder<T extends DTO> = Convertor<T> & {
  encode(data: T): DataView
}

export type Convertor<T extends DTO> = {
  readonly uuid: UUID
  type: new () => T
}
